import { render, staticRenderFns } from "./LastResultsView.vue?vue&type=template&id=ac0fd7da&scoped=true"
import script from "./LastResultsView.vue?vue&type=script&lang=js"
export * from "./LastResultsView.vue?vue&type=script&lang=js"
import style0 from "./LastResultsView.vue?vue&type=style&index=0&id=ac0fd7da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0fd7da",
  null
  
)

export default component.exports